import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon } from "lucide-react";
import { kinetips } from "../../data/kinetips";
export function KinetipsSection() {
  return <section className="bg-white" data-id="element-193" data-mp="1jfyyb2c9z4z">
      <div className="mx-auto max-w-6xl px-5 py-20 md:px-8 md:py-24" data-id="element-194" data-mp="1iep29x27iou">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between" data-id="element-195" data-mp="3tmz2ykxkqopg">
          <div className="max-w-xl" data-id="element-196" data-mp="35xo6hfn9bgh4">
            <h2 className="text-3xl font-semibold tracking-tight text-ink md:text-4xl" data-id="element-197" data-mp="35ypmlyj4qt5p">Kinétips</h2>
            <p className="mt-3 text-base leading-relaxed text-muted" data-id="element-198" data-mp="3104gxjl3zh9v">
              Les conseils du cabinet pour mieux comprendre votre corps au quotidien.
            </p>
          </div>
          <Link to="/kinetips" className="inline-flex items-center gap-2 text-sm font-medium text-brand underline-offset-4 hover:underline" data-id="element-199" data-mp="39yghadbs1tfi">
            Tous les articles
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-200" data-mp="2i7k4tdtmpqsr" />
          </Link>
        </div>

        <div className="mt-10 grid gap-10 md:grid-cols-2" data-id="element-201" data-mp="1f3htoktgqh23">
          {kinetips.map(tip => <article key={tip.id} data-id="element-202" data-mp="1k21hyrvj44xm">
              <Link to="/kinetips" className="group block" data-id="element-203" data-mp="1k19k1aeglv46">
                <div className="overflow-hidden rounded-2xl" data-id="element-204" data-mp="1ov45ai9pqi5d">
                  <img src={tip.image} alt={tip.imageAlt} className="aspect-[3/2] w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.02]" data-id="element-205" data-mp="1tsw661sc5elp" />
                </div>
                <p className="mt-5 text-xs text-muted" data-id="element-206" data-mp="116kvtzexfzbp">
                  {tip.date} · {tip.readTime}
                </p>
                <h3 className="mt-2 text-xl font-semibold leading-snug text-ink underline-offset-4 group-hover:underline" data-id="element-207" data-mp="1b2o31jomyo5i">
                  {tip.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-208" data-mp="2hkugojjyn5xs">{tip.excerpt}</p>
              </Link>
            </article>)}
        </div>
      </div>
    </section>;
}